export default function KeyConceptsContent() {
  return (
    <div>
      <p className="mb-4">
        The Justin Legal API is designed to facilitate digital client
        onboarding and case management for law firms. Key concepts include:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Forms and Areas of Law:</strong> Forms define which data is
          collected for a legal matter and are organized by AreasOfLaw and
          CaseTypes.
        </li>
        <li>
          <strong>CaseFiles:</strong> CaseFiles are the central records that
          hold the matter data, current status, metadata, owner, and submission
          state.
        </li>
        <li>
          <strong>Related Entities:</strong> Contacts, Relationships,
          Insurances, and CustomEntities add structured details to a CaseFile.
        </li>
        <li>
          <strong>Documents and Exports:</strong> CaseDocuments can be uploaded,
          generated, downloaded, renamed, deleted, and exported with the case
          data.
        </li>
      </ul>
    </div>
  );
}
